
<fieldset>
  <GooglePlacesTextField
    id="address_line_1"
    v-model="form.addressLine1"
    labelName="Address"
    name="address-line1"
    class="mb-16"
    :status="formStatuses.addressLine1"
    :helperText="helperText(formStatuses.addressLine1, 'Street address')"
    @autoCompletedAddresses="setAddresses"
    @blur="validateRequiredFields('addressLine1', form.addressLine1)"
  />
  <!-- Address Line 2 is always optional, so we do not validate it -->
  <PoppinsTextField
    id="address_line_2"
    v-model="form.addressLine2"
    labelName="Apartment, suite, etc (optional)"
    name="address-line2"
    type="text"
    class="mb-16"
  />
  <PoppinsTextField
    id="city"
    v-model="form.city"
    labelName="City"
    name="city"
    type="text"
    class="mb-16"
    :status="formStatuses.city"
    :helperText="helperText(formStatuses.city, 'City')"
    @blur="validateRequiredFields('city', form.city)"
  />
  <PoppinsDropdown
    id="state"
    v-model="form.stateCode"
    labelName="State"
    name="state"
    class="mb-16"
    :options="states"
    :status="formStatuses.stateCode"
    :helperText="helperText(formStatuses.stateCode, 'State')"
    @blur="validateRequiredFields('stateCode', form.stateCode)"
  />
  <PoppinsTextField
    id="postal_code"
    v-model="form.postalCode"
    labelName="ZIP code"
    name="postal-code"
    type="text"
    maxlength="5"
    pattern="[0-9]*"
    class="mb-24"
    inputmode="numeric"
    :status="formStatuses.postalCode"
    :helperText="helperText(formStatuses.postalCode, 'ZIP code', form.postalCode)"
    @blur="validateZipcode"
  />
</fieldset>
